<template>
    <div class="disease-result">
        <!-- 顶部区域：展示病害图片和名称/置信度 -->
        <div class="result-header">
            <!-- 左侧放置图片，使用用户上传的第一张图片 -->
            <div class="disease-image" v-if="resultImage">
                <img :src="resultImage" alt="病害图片" @click="showFullImage">
            </div>
            <div class="disease-info">
                <div class="disease-name-confidence">
                    <span>{{ cropName }}</span>
                    <span class="disease-name">{{ diseaseName }}</span>
                    <span class="confidence">({{ confidenceText }})</span>
                </div>
                <!-- 病害特征描述 -->
                <div class="result-feature" v-if="displayFeature">
                    <p>{{ displayFeature }}</p>
                </div>
            </div>
        </div>

        <!-- 详细描述部分(暂时不展示) -->
        <!-- <div class="result-description border-style" v-if="description">
            <span class="description-title">详细描述</span>
            <span class="description-content">{{ description }}</span>
        </div> -->

        <!-- 治疗方案建议 -->
        <div v-if="diseaseName !== '健康' && hasTreatmentMethods && showMethods" class="method-title">治疗方案建议</div>
        <div v-if="diseaseName !== '健康' && hasTreatmentMethods && showMethods" class="result-method treatment-section">

            <div class="method-content">
                <!-- 防治方法，使用列表形式展示 -->
                <div class="treatment-method border-style" v-if="showPhysics">
                    <!-- <span>物理防治方法</span> -->
                    <p class="left-align">物理防治方法</p>
                    <p class="bullet-list">
                        <span v-for="(item, index) in displayPhysics" :key="index" class="bullet-item">
                            {{ item }}
                        </span>
                    </p>
                </div>
                <div class="treatment-method border-style" v-if="showBiology">
                    <p class="left-align">生物防治方法</p>
                    <p class="bullet-list">
                        <span v-for="(item, index) in displayBiology" :key="index" class="bullet-item">
                            {{ item }}
                        </span>
                    </p>
                </div>
                <div class="treatment-method border-style" v-if="showChemistry">
                    <p class="left-align">化学防治方法</p>
                    <p class="bullet-list">
                        <span v-for="(item, index) in displayChemistry" :key="index" class="bullet-item">
                            {{ item }}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.disease-result {
    color: #303030;
    font-style: normal;
    width: 755px;
    background-color: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    padding-bottom: 20px;
}

/* 边框样式 */
.border-style {
    width: 695px;
    border-radius: 0px 20px 20px 20px;
    padding: 20px;
    background-color: #F3F3F3;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: left;
}

.left-align {
    text-align: left;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #303030;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    margin-bottom: 10px;
}
.bullet-list {
    white-space: normal;
    /* 移除 pre-wrap，避免干扰 */
    margin: 0;
    /* 清除默认外边距 */
    padding-left: 0;
    /* 清除默认内边距 */
}
.bullet-item {
    display: block;
    /* 强制每个条目独占一行 */
    margin-bottom: 4px;
    /* 可选：添加条目间距 */
}
.bullet-item::before {
    content: '';
    display: inline-block;
    width: 7px;
    height: 7px;
    background: #000;
    border-radius: 50%;
    margin-right: 8px;
    vertical-align: middle;
    position: relative;
    top: -1px;
    /* 微调垂直对齐 */
}
/* 结果头部 */
.result-header {
    display: flex;
    padding: 16px;
    background-color: #ffffff;
    align-items: center;
}

.disease-image {
    width: 156px;
    height: 165px;
    border-radius: 6px;
    overflow: hidden;
    margin-right: 16px;
    flex-shrink: 0;
    border: 1px solid #f0f0f0;
    cursor: pointer;
    transition: transform 0.2s ease;
}

.disease-image:hover {
    transform: scale(1.05);
}

.disease-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.disease-info {
    height: 156px;
    display: flex;
    flex-direction: column;
    margin-left: 20px;
}

.disease-name-confidence {
    /* 两个span水平排列靠左摆放 */
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    font-size: 30px;
    font-weight: 600;
}

.disease-name {
    margin-right: 22px;
}

/* 病害特征描述 */
.result-feature {
    margin-top: 20px;
}

.result-feature p {
    margin: 0;
    width: 539px;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
}

/* 详细描述 */
.result-description {
    margin-top: 20px;
}

.result-description span {
    text-align: left;
    width: 662px;
}

.description-title {
    font-size: 16px;
    font-weight: 500;
    margin: 0 0 12px 0;
}

.description-content {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
}

/* 治疗方案建议 */
.method-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    text-align: left;
    margin-top: 20px;
    margin-left: 30px;
}

.method-content {
    margin-top: 10px;
}

.treatment-method {
    margin-bottom: 20px;
}

.treatment-method p {
    text-align: left;
}

.treatment-method div {
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;

}

.method-list {
    margin: 0;
    padding-left: 20px;
    list-style-type: disc;
}

.method-list li {
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 1.5;
    color: #666666;
    position: relative;
}

.method-list li::before {
    content: "•";
    position: absolute;
    left: -15px;
    color: #666666;
}

.general-method p {
    margin: 0;
    white-space: pre-line;
}
</style>

<script>
export default {
    name: 'DiseaseResult',
    props: {
        resultData: {
            type: Object,
            required: true
        },
        imageUrl: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            displayFeature: '',
            displayPhysics: [],
            displayBiology: [],
            displayChemistry: [],
            streamInterval: null,
            streamStage: 'feature', // 'feature', 'physics', 'biology', 'chemistry', 'complete'
            currentIndex: 0,
            showMethods: false,
            showPhysics: false,
            showBiology: false,
            showChemistry: false
        }
    },
    computed: {
        confidenceText() {
            const conf = Number(this.confidence);
            if (conf > 90) return '极大概率';
            if (conf >= 70) return '大概率';
            if (conf >= 50) return '中等概率';
            if (conf >= 30) return '小概率';
            return '极小概率';
        },
        resultImage() {
            // 优先使用传入的图片，否则尝试从resultData中获取
            return this.imageUrl || null;
        },
        diseaseName() {
            if (this.resultData && this.resultData.data && this.resultData.data.data) {
                const data = this.resultData.data.data;
                if (data[0].label) {
                    return data[0].label;
                } else if (data[0].confidences && data[0].confidences.length > 0) {
                    return data[0].confidences[0].label;
                }
            }
            return '未知病害';
        },
        cropName() {
            console.log(this.resultData);
            if (this.resultData && this.resultData.cropName) {
                return this.resultData.cropName;
            }
            return '未知作物';
        },
        confidence() {
            if (this.resultData && this.resultData.data && this.resultData.data.data) {
                const data = this.resultData.data.data;
                if (data[0].confidences && data[0].confidences.length > 0) {
                    return (data[0].confidences[0].confidence * 100).toFixed(0); // 去掉小数点
                }
            }
            return 0;
        },
        description() {
            if (this.resultData && this.resultData.data && this.resultData.data.data) {
                return this.resultData.data.data[1] || '';
            }
            return '';
        },
        feature() {
            return this.resultData?.feature || '';
        },
        physics() {
            return this.resultData?.physics || '';
        },
        chemistry() {
            return this.resultData?.chemistry || '';
        },
        biology() {
            return this.resultData?.biology || '';
        },
        hasTreatmentMethods() {
            // 检查所有治疗方法是否都为空
            return this.physics.trim() !== '' || this.chemistry.trim() !== '' || this.biology.trim() !== '';
        },
        formattedPhysics() {
            return this.physics.split('\n').map(item => item.replace(/^- /, ''));
        },
        formattedChemistry() {
            return this.chemistry.split('\n').map(item => item.replace(/^- /, ''));
        },
        formattedBiology() {
            return this.biology.split('\n').map(item => item.replace(/^- /, ''));
        },
        methodHasCategories() {
            // 检查method文本中是否包含"物理防治方法"或"生物防治方法"
            const methodText = this.method || '';
            return methodText.includes('物理防治方法') || methodText.includes('生物防治方法');
        }
    },
    watch: {
        resultData: {
            immediate: true,
            handler() {
                // 重置所有显示内容
                this.resetStreaming();
                // 开始流式显示
                this.startStreaming();
            }
        }
    },
    methods: {
        resetStreaming() {
            if (this.streamInterval) {
                clearInterval(this.streamInterval);
            }
            
            this.displayFeature = '';
            this.displayPhysics = [];
            this.displayBiology = [];
            this.displayChemistry = [];
            this.streamStage = 'feature';
            this.currentIndex = 0;
            this.showMethods = false;
            this.showPhysics = false;
            this.showBiology = false;
            this.showChemistry = false;
        },
        
        startStreaming() {
            // 每50毫秒执行一次流式显示
            this.streamInterval = setInterval(this.streamContent, 50);
        },
        
        streamContent() {
            // 根据当前阶段执行对应的流式显示
            switch(this.streamStage) {
                case 'feature':
                    this.streamFeature();
                    break;
                case 'physics':
                    this.streamPhysics();
                    break;
                case 'biology':
                    this.streamBiology();
                    break;
                case 'chemistry':
                    this.streamChemistry();
                    break;
                case 'complete':
                    clearInterval(this.streamInterval);
                    break;
            }
        },
        
        streamFeature() {
            if (this.currentIndex < this.feature.length) {
                // 每次添加两个字符
                const charsToAdd = Math.min(2, this.feature.length - this.currentIndex);
                this.displayFeature = this.feature.substring(0, this.currentIndex + charsToAdd);
                this.currentIndex += charsToAdd;
            } else {
                // 特征描述显示完毕，准备显示防治方法
                this.showMethods = true;
                this.showPhysics = true;
                this.currentIndex = 0;
                this.streamStage = 'physics';
            }
        },
        
        streamPhysics() {
            const physicsItems = this.formattedPhysics;
            if (physicsItems.length === 0 || physicsItems[0] === '') {
                // 没有物理防治方法，跳到生物防治方法
                this.showBiology = true;
                this.currentIndex = 0;
                this.streamStage = 'biology';
                return;
            }
            
            if (this.currentIndex < physicsItems.length) {
                // 逐项添加
                const displayItems = [...this.displayPhysics];
                const currentItem = physicsItems[this.currentIndex];
                
                // 已经添加了当前项，但还没有完整显示
                if (displayItems.length > this.currentIndex) {
                    const itemLength = currentItem.length;
                    const displayedLength = displayItems[this.currentIndex].length;
                    
                    if (displayedLength < itemLength) {
                        // 继续显示当前项
                        const charsToAdd = Math.min(2, itemLength - displayedLength);
                        displayItems[this.currentIndex] = currentItem.substring(0, displayedLength + charsToAdd);
                        this.displayPhysics = displayItems;
                    } else {
                        // 当前项显示完毕，移动到下一项
                        this.currentIndex++;
                    }
                } else {
                    // 添加新项
                    displayItems.push('');
                    this.displayPhysics = displayItems;
                }
            } else {
                // 物理防治方法显示完毕，进入生物防治方法
                this.showBiology = true;
                this.currentIndex = 0;
                this.streamStage = 'biology';
            }
        },
        
        streamBiology() {
            const biologyItems = this.formattedBiology;
            if (biologyItems.length === 0 || biologyItems[0] === '') {
                // 没有生物防治方法，跳到化学防治方法
                this.showChemistry = true;
                this.currentIndex = 0;
                this.streamStage = 'chemistry';
                return;
            }
            
            if (this.currentIndex < biologyItems.length) {
                // 逐项添加
                const displayItems = [...this.displayBiology];
                const currentItem = biologyItems[this.currentIndex];
                
                // 已经添加了当前项，但还没有完整显示
                if (displayItems.length > this.currentIndex) {
                    const itemLength = currentItem.length;
                    const displayedLength = displayItems[this.currentIndex].length;
                    
                    if (displayedLength < itemLength) {
                        // 继续显示当前项
                        const charsToAdd = Math.min(2, itemLength - displayedLength);
                        displayItems[this.currentIndex] = currentItem.substring(0, displayedLength + charsToAdd);
                        this.displayBiology = displayItems;
                    } else {
                        // 当前项显示完毕，移动到下一项
                        this.currentIndex++;
                    }
                } else {
                    // 添加新项
                    displayItems.push('');
                    this.displayBiology = displayItems;
                }
            } else {
                // 生物防治方法显示完毕，进入化学防治方法
                this.showChemistry = true;
                this.currentIndex = 0;
                this.streamStage = 'chemistry';
            }
        },
        
        streamChemistry() {
            const chemistryItems = this.formattedChemistry;
            if (chemistryItems.length === 0 || chemistryItems[0] === '') {
                // 没有化学防治方法，显示完成
                this.streamStage = 'complete';
                return;
            }
            
            if (this.currentIndex < chemistryItems.length) {
                // 逐项添加
                const displayItems = [...this.displayChemistry];
                const currentItem = chemistryItems[this.currentIndex];
                
                // 已经添加了当前项，但还没有完整显示
                if (displayItems.length > this.currentIndex) {
                    const itemLength = currentItem.length;
                    const displayedLength = displayItems[this.currentIndex].length;
                    
                    if (displayedLength < itemLength) {
                        // 继续显示当前项
                        const charsToAdd = Math.min(2, itemLength - displayedLength);
                        displayItems[this.currentIndex] = currentItem.substring(0, displayedLength + charsToAdd);
                        this.displayChemistry = displayItems;
                    } else {
                        // 当前项显示完毕，移动到下一项
                        this.currentIndex++;
                    }
                } else {
                    // 添加新项
                    displayItems.push('');
                    this.displayChemistry = displayItems;
                }
            } else {
                // 所有内容显示完毕
                this.streamStage = 'complete';
            }
        },
        
        showFullImage() {
            // 发出事件，让父组件显示全屏预览
            if (this.resultImage) {
                this.$emit('show-full-image', this.resultImage);
            }
        },
        
        getMethodItems(category) {
            // 解析防治方法，提取特定类别下的项目
            const methodText = this.method || '';
            if (!methodText.includes(category)) {
                return [];
            }

            // 简单的解析逻辑，可能需要根据实际数据格式调整
            try {
                // 寻找类别后面的列表项（假设列表项以"•"或"-"开头）
                const regex = new RegExp(`${category}[\\s\\S]*?((?:•|-).*?)(?:物理防治方法|生物防治方法|$)`, 'i');
                const match = methodText.match(regex);
                if (match && match[1]) {
                    // 拆分为列表项
                    return match[1].split(/•|-/)
                        .map(item => item.trim())
                        .filter(item => item.length > 0);
                }
            } catch (e) {
                console.error('解析防治方法失败', e);
            }

            return [];
        }
    },
    beforeDestroy() {
        // 组件销毁前清除定时器
        if (this.streamInterval) {
            clearInterval(this.streamInterval);
        }
    }
}
</script>
